import { ReactNode } from 'react';
import { Flex, VStack, Icon, cssVar } from '@cad-arc';

export function FrClickableCard({
    children,
    handleCardClick,
}: {
    children: ReactNode;
    handleCardClick?: () => void;
}) {
    return (
        <Flex
            width="100%"
            alignItems="flex-start"
            justifyContent="space-between"
            borderRadius={`${cssVar('arc.space.1')}`}
            borderWidth="1px"
            borderColor="border.default"
            backgroundColor="surface.foreground"
            padding={cssVar('arc.space.3')}
            {...(handleCardClick
                ? {
                      onClick: handleCardClick,
                      role: 'button',
                      _hover: {
                          backgroundColor: 'surface.accent',
                          cursor: 'pointer',
                      },
                  }
                : {})}
        >
            <VStack justifyContent="center" alignItems="flex-start">
                {children}
            </VStack>
            <VStack height="100%" justifyContent="center">
                {handleCardClick && <Icon size="md" icon="OpenNewWindow" color="brand.default" />}
            </VStack>
        </Flex>
    );
}
